////////
// Carousel
// - Manages all internal behaviours to do with a carousel
////////
var Carousel = function(element) {

	this.selectors = {
		paneWrapper: 	".carousel-panes",
		pane: 				".carousel-pane",
		pagination: 	".carousel-pagination",
		bar: 					".bar" // NOTE: Update to have prefix
	};
	this.flags = {
		ACTIVE: "active",
		HIDE: "hide"
	};

	// Code setup
	this.element = $(element);
	this.element.attr("data-carousel-ready", true);
	this.paneWrapper = this.element.one(this.selectors.paneWrapper);
	this.panes = this.element.find(this.selectors.pane);
	this.pagination = null;
	this.intervalId = null;
	this.activePane = null

	// Set duration
	if(this.element.attr("data-carousel-duration")) {
		this.duration = Number(this.element.attr("data-carousel-duration"));
	} else {
		this.duration = 8000;
	}

	// Pagination controls
  this.updatePagination = function(index, pane) {
		if(this.pagination) {
	  	var i = index + 1;
	  	this.pagination.find(this.selectors.bar).removeClass(this.flags.ACTIVE);
	  	this.pagination.find(this.selectors.bar + ":nth-of-type(" + i + ")").addClass(this.flags.ACTIVE);
		}
  }

	// Previous and next controls
	if(this.element.attr("data-carousel-controls") == "true" && this.panes.length > 1) {
		this.paneWrapper.prepend(
			'<div class="carousel-control btn-page" role="Next"></div>'
			+ '<div class="carousel-control btn-page" role="Previous"></div>'
		);

		// Get buttons
		this.nextButton = this.element.find(".carousel-control[role='Next']");
		this.prevButton = this.element.find(".carousel-control[role='Previous']");

		// Add click methods
		this.nextButton.on("click", this, function(e) {
			var obj = e.data;
			var index = obj.getActiveIndex();

			// Get next
			index += 1;
			if(index == obj.panes.length) {
				index = 0;
			}

			// Show pane
			obj.displayPane(index);
		});

		this.prevButton.on("click", this, function(e) {
			var obj = e.data;
			var index = obj.getActiveIndex();

			// Get next
			index -= 1;
			if(index < 0) {
				index = obj.panes.length - 1;
			}

			// Show pane
			obj.displayPane(index);

		});
	}

	// Add pagination
	if(this.element.attr("data-carousel-pagination") == "true" || !this.element.attr("data-carousel-pagination") ) {
		if(this.panes.length > 1) {
			this.renderPaginationControl();
		}
	}

	// Only initiate if there are multiple panes
	if(this.panes.length > 1) {
		this.displayPane(0);
    this.autoCarousel();
	}
}

Carousel.prototype.autoCarousel = function() {
	var obj = this;

	// Remove old timer if applicable
	if(this.intervalId !== null) {
		clearInterval(this.intervalId);
	}

	// Start new one
  this.intervalId = setInterval(function() {
    obj.displayNextPane()
  }, this.duration);
}

Carousel.prototype.getActiveIndex = function() {
	// Find the index of the active pane
	var index, flag = this.flags.ACTIVE;
	$.each(this.panes,function(i, pane) {
		if($(pane).hasClass(flag)) {
			index = i;
		};
	});
	return(index);
}

// Displays the next pane
Carousel.prototype.displayNextPane = function() {
  try {
		index = this.getActiveIndex();

    // Increment index
    index += 1;

    // Reset to start
    if(index == this.panes.length) {
      index = 0;
    }

    // Display pane
    this.displayPane(index);

  } catch(e) {
    console.log("Next pane not found ", e);
  }
}

// Display a specific pane based on Array index in this.pane collection
Carousel.prototype.displayPane = function(paneIndex) {
  var obj = this;
  var active = this.panes[paneIndex];

	// Check if there is a previous active pane, as we want to hide this
	if(this.activePane) {
		this.activePane.addClass(this.flags.HIDE);

		// TIMER FOR HAVING A HIDE PROCESS
		var a = setTimeout(function() {
			obj.setActivePane(paneIndex);
		}, 500);
	} else {
		this.setActivePane(paneIndex);
	}

}

Carousel.prototype.setActivePane = function(paneIndex) {
	var active = this.panes[paneIndex];
	var obj = this;

	// Remove active classes from anywhere else
	$.each(this.panes, function(i, pane) {
    $(pane).removeClass(obj.flags.ACTIVE + " " + obj.flags.HIDE);
	});

	// Set new active state
	this.activePane = $(active);
  this.activePane.addClass(this.flags.ACTIVE);
	this.updatePagination(paneIndex);
	this.autoCarousel();
}

// Update pagination after a pane change
Carousel.prototype.updatePagination = function(paneIndex) {
	var i = index + 1;

	this.pagination.find(this.selectors.bar).removeClass(this.flags.ACTIVE);
	this.pagination.find(this.selectors.bar + ":nth-of-type(" + i + ")").addClass(this.flags.ACTIVE);
}

// Click handler for the .bar elements
Carousel.prototype.onBarClick = function(activeBar) {
	var bars = this.pagination.find(this.selectors.bar);
  var obj = this;

	$(bars).removeClass(this.flags.ACTIVE);
	$.each(bars, function(i, bar) {
		if(bar == activeBar) {
			obj.displayPane(i);
		}
	});
}

// Render the pagination control into the DOM
Carousel.prototype.renderPaginationControl = function() {
	var bar = '<span class="bar"></span>';
  var obj = this;
	$(this.paneWrapper).append(
		'<div class="carousel-pagination">'
		+ bar.repeat(this.panes.length)
		+ '</div>'
	);
	this.pagination = this.element.find(this.selectors.pagination);
	$(this.pagination).find(this.selectors.bar).on("click", function(e) {
		obj.onBarClick(e.srcElement);
	});
}
